import { translator } from '#/features/localization/utils';
import { UsernameFormState } from './username-form-context-state';

export interface UsernameFormView {
  readonly values: {
    readonly username: string;
    readonly isUsernamePrivate: boolean;
  };
  // Whether fields have been touched by the user
  readonly touched: {
    readonly username: boolean;
    readonly isUsernamePrivate: boolean;
  };
  /** Errors by field computed on the client */
  readonly errors: {
    readonly username: string;
  };
  /**
   * Whether form is being submitted.
   * Indicates whether form should be prevented from being interacted with.
   */
  readonly isSubmitting: boolean;
  /** Indicates whether form must be prevented from being submitted. */
  readonly canSubmit: boolean;
  /** Any server errors generated on form submission */
  readonly error: string;
}

export function createView(state: UsernameFormState): UsernameFormView {
  const errors = errorsView(state);
  const isValid = Object.entries(errors).every(
    ([, error]) => error.length === 0,
  );
  const wasTouched = Object.entries(state.touched).some(
    ([, touched]) => touched,
  );
  const canSubmit = !state.isSubmitting && isValid && wasTouched;
  return {
    values: state.values,
    touched: state.touched,
    errors,
    isSubmitting: state.isSubmitting,
    canSubmit,
    error: state.error,
  };
}

function errorsView(state: UsernameFormState): UsernameFormView['errors'] {
  return {
    username: usernameErrorsView(state),
  };
}

const USERNAME_ALLOWED_CHARS_REGEX = /^[a-zA-Z0-9]+$/u;

function usernameErrorsView(state: UsernameFormState): string {
  if (state.values.username.length === 0)
    return translator.t('Username is required');
  if (state.values.username.length < 5 || state.values.username.length > 20)
    return translator.t('Username must be between 5 and 20 characters');
  if (!USERNAME_ALLOWED_CHARS_REGEX.test(state.values.username))
    return translator.t('Username can only contain letters and numbers');
  return '';
}
